import api from "@wallet-manager/node-types/dist/src/access/APIEndpoints/index";
import axios from "./axiosInstance";

const { EPtAssetManagement } = api;

export async function getContractSweepRequestRecord(params: any, config?: any) {
  const { pageSize, page, ...rest } = params;
  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get(
    EPtAssetManagement.EndPtContractSweepRequest.getAll,
    input,
  );
}

export async function getContractSweepRequestRecordExport(
  params: any,
  config?: any,
) {
  const { pageSize, page, ...rest } = params;

  const payload = { ...rest, limit: pageSize, offset: pageSize * page };

  return await axios.get<never, any>(
    EPtAssetManagement.EndPtContractSweepRequest.export,
    {
      params: { ...payload },
      ...config,
    },
  );
}

export async function getContractSweepRequestRecordResubmit(data: any) {
  const url = EPtAssetManagement.EndPtContractSweepRequest.resubmit;
  const payload = {
    ...data,
  };
  return axios.post(url, payload);
}
